const prefix = "dl-";

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
};

const getCustomerObject = async () => {
  const storeURL = fx_local_scripts.store_base_url;
  const customer = getCookie("foxy-session-token");

  if (!storeURL || !customer) {
    return;
  }

  try {
    const response = await fetch(
      `${storeURL}/s/customer/attributes?limit=300&name=${prefix}*&order=date_created desc`,
      {
        method: "GET",
        headers: {
          "fx.customer": customer.replace(/ /g, "+"),
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Response error: ${response.status} ${response.statusText}`
      );
    }

    return response.json();
  } catch (error) {
    console.error("Error getting customer object", error);
  }
};

const decodeHtmlEntities = (str) => {
  return str
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, "&")
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");
};

const escapeQuotesInTitle = (str) => {
  // Regular expression to match and capture the "title" field with any content
  const regex = /"title":"(.*?)"[,}]/;
  // Replace double quotes within the captured title with single quotes
  return str.replace(regex, (match, p1) => {
    const fixedTitle = p1.replace(/"/g, "'").replace(/\\/g, "");
    return `"title":"${fixedTitle}",`;
  });
};
const getDownloadItems = async () => {
  const customerObject = await getCustomerObject();

  if (
    !customerObject ||
    !customerObject._embedded ||
    !customerObject._embedded["fx:attributes"]
  ) {
    return;
  }

  return customerObject._embedded["fx:attributes"]
    .filter((attribute) => attribute.name.includes(prefix))
    .map((attribute) => {
      let values = attribute.value;

      if (values.includes("&quot;")) {
        values = decodeHtmlEntities(values);
        values = escapeQuotesInTitle(values);
      }

      values = JSON.parse(values);

      if (values.download_url) {
        values.download_url = values.download_url.replace(/&amp;/g, "&");
      }

      values["date_created"] = attribute.date_created;
      return values;
    });
};

window.__monthlyReview = {
  downloadsItems: getDownloadItems,
};
